import { render, staticRenderFns } from "./ClientList.vue?vue&type=template&id=43692116&scoped=true&"
import script from "./ClientList.vue?vue&type=script&lang=js&"
export * from "./ClientList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43692116",
  null
  
)

export default component.exports